/*
 * @Description:
 * @Autor: Chen
 * @Date: 2020-01-21 14:30:41
 * @LastEditors: snzo.chen
 * @LastEditTime: 2022-03-10 15:38:32
 */
import { Injectable, Inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {
  API_CONFIG_ADMIN,
  API_CONFIG_KNOWLEDGE,
  API_CONFIG_UNION,
} from '../services.module';
import { tap } from 'rxjs/internal/operators';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    @Inject(API_CONFIG_ADMIN) private uri: string,
    @Inject(API_CONFIG_KNOWLEDGE) private knowledgeUri: string,
    @Inject(API_CONFIG_UNION) private unionUri: string,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq: HttpRequest<any>;
    if (req.url.indexOf('http') !== -1 || req.url.indexOf('https') !== -1) {
      authReq = req;
    } else if (req.url.indexOf('user') !== -1) {
      authReq = req.clone({
        url: this.uri + req.url,
        headers: req.headers.set(
          'Authorization',
          'Bearer ' + this.authService.token
        ),
      });
    } else if (req.url.indexOf('knowledge') !== -1) {
      authReq = req.clone({
        url: this.knowledgeUri + req.url,
      });
    } else if (req.url.indexOf('lianmeng') !== -1) {
      authReq = req.clone({
        url: this.unionUri + req.url,
      });
    } else {
      authReq = req.clone({
        url: this.uri + req.url,
        headers: req.headers.set(
          'Authorization',
          'Bearer ' + this.authService.token
        ),
      });
    }
    return (
      next
        // 返回处理后的请求
        .handle(authReq)
        // 返回结果错误处理
        .pipe(
          tap(
            (event) => {
              if (event instanceof HttpResponse) {
                const response = event.body;
                return of(
                  new HttpResponse(Object.assign(event, { body: response }))
                );
              }
            },
            (error) => {}
          )
        )
    );
  }
}
